import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Heading from '../../components/Heading';
import CompaniesList from '../../components/CompaniesList';
import VacanciesList from '../../components/VacanciesList';
import CitySelect from '../../components/CitySelect';
import AboutHoldingSection from '../../components/AboutHoldingSection';
import Button from '../../components/Button';
import Select from '../../components/Select';
import HoldingAdvantages from '../../components/HoldingAdvantages';
import PopularVacancies from '../../components/PopularVacancies';
import PromotionCards from '../../components/PromotionCards';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setFilterData } from "../../actions/FiltersActions";
import headerImage from '../../assets/imgs/header_russia.png';
import headerImage__1024 from '../../assets/imgs/header_russia.png';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadVacancies } from '../../actions/VacanciesActions';
import { loadCompanies } from '../../actions/CompaniesActions';
import { loadScopeActivity } from '../../actions/ScopeActivityActions';
import { loadCities } from '../../actions/CitiesActions';
import { loadPersonal } from '../../actions/PersonalActions';

import LogoDomRu from '../../assets/imgs/logos_2024/domru.png'
import LogoDomRuBusiness from '../../assets/imgs/logos_2024/domru_business.png'
import LogoAkado from '../../assets/imgs/logos_2024/akado.png'
import LogoAvantel from '../../assets/imgs/logos_2024/avantel.png'
import LogoGreenTech from '../../assets/imgs/logos_2024/greentech.png'

import LogoECity from '../../assets/imgs/logo-e-city.png'
import LogoEnforta from '../../assets/imgs/logo-enforta.png'

const mappingScope = (array, newArray) => {
  if (array) {
    for (let i = 0; i < array.length; i++) {
      newArray[i] = {
        label: array[i].name,
        value: array[i].id,
        amount: array[i].vacancy_count
      }
    }
  }
}

class PageMain extends Component {
  static requestData(store) {
    return requestAll([loadVacancies, loadCompanies, loadScopeActivity, loadCities, loadPersonal], store);
  }

  componentDidMount() {
    this.props.actions.loadCompanies();
    this.props.actions.loadVacancies('popular', true);
    this.props.actions.loadCompanies(this.props.filter);
    this.props.actions.loadCities();
    this.props.actions.loadScopeActivity(this.props.filter);
  }
  render() {
    let filteredCompanies = this.props.companies;
    const filterName = this.props.filter;
    let filterValue = filterName["city"].id;
    if (filterValue && filteredCompanies.length > 0) {
      filteredCompanies = filteredCompanies.filter(function(item) {
        if (Array.isArray(item.cities)) {
          for (var i = 0; i < item.cities.length; i++) {
            if (item.cities[i].id === filterValue) {
              return item.cities[i].id === filterValue;
            }
          }
        }
        else {
          return item.cities.id === filterValue;
        }
      });
    }

    const scope_activity = [];
    mappingScope(this.props.scope_activity, scope_activity);
    scope_activity.unshift({label: "Все сферы деятельности"});

    return (
      <div>
        <Helmet>
          <title>Работа в телекоммуникационной компании | Вакансии в ЭР-Телеком Холдинг в Перми</title>
          <meta name="description" content="Найдите вакансии в телекоммуникационной компании ЭР-Телеком Холдинг. Работа в Перми, карьерные возможности в сфере связи и технологий. Присоединяйтесь к нашей команде и развивайтесь с нами!" />
        </Helmet>
        <Heading
          background={headerImage} //заменено
          background__1024={headerImage__1024} //не понимаю в чем разница в файлах, оставил без изменений
          withoutBG={true}
          modifier="heading--fullHeight heading--flexContent"
        >
          <div className="container container--hide-mobile"></div>
          <div className="container container--center">
            <h1 className="text--hide">Работа в Санкт-Петербурге. Работа в ЭР-Телеком Холдинг</h1>
            <CitySelect modifier="citySelect--white">Работа</CitySelect>
            <div className="text text--increase">Вместе в гигабитное будущее</div>
          </div>
        </Heading>
        <div className="container container--indentVertical container--indentVertical-top">
          <div className="row row--smallOffset">
            <div className="col col--7 colTablet--12">
              <Select name="scopeActivity" value={{label: this.props.filter.scope_activity.label, id: this.props.filter.scope_activity.id}} options={scope_activity} placeholder="Все сферы деятельности" modifier="Select--tell" type="scope_activity" changeOption={this.props.handleChange} alphabeticSort={true} />
            </div>
            <div className="col col--5 colTablet--12">
              <Button link="/vacancies" class="goal102" text="Найти любимую работу" modifier="button--wide" />
            </div>
          </div>
        </div>
        <div className="container main-page-container-gaps">
          <AboutHoldingSection />
          <p className="text text--increase main-page-text-gap font-weight--600">Стань частью нашей яркой команды!</p>
          <div className="main-page-companies">
            <div className="main-page-company main-page-company--first">
              <img src={LogoDomRu} width={95} height={60}/>
            </div>
            <div className="main-page-company main-page-company--second">
              <img src={LogoDomRuBusiness} width={90} height={80}/>
            </div>
            <div className="main-page-company">
              <img src={LogoAkado} width={90} height={60}/>
            </div>
            <div className="main-page-company">
              <img src={LogoAvantel} width={130} height={60}/>
            </div>
            <div className="main-page-company main-page-company--fourth">
              <img src={LogoGreenTech} width={120} height={70}/>
            </div>
          </div>
        </div>
        <HoldingAdvantages/>
        <PromotionCards/>
        <div className="container container--indentVertical">
          <div className="main-page-popular-header">
          <h2 className="text text--h2">Популярные вакансии</h2>
          </div>
          <PopularVacancies vacancies={this.props.vacancies.list} />
          <Button link="vacancies" text="Показать все вакансии" />
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      this.props.actions.loadCompanies(nextProps.filter);
      this.props.actions.loadScopeActivity(nextProps.filter);
    }
  }
}

const mapStateToProps = (state) => {
  return {
      vacancies: state.vacancies,
      companies: state.companies.list,
      scope_activity: state.scope_activity.list,
      hasErrored: state.vacancies.hasErrored || state.cities.hasErrored || state.companies.hasErrored,
      isLoading: state.vacancies.isLoading || state.cities.isLoading || state.companies.isLoading,
      filter: state.filter,
      cities: state.cities.list
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadVacancies, loadCompanies, loadScopeActivity, loadCities }, dispatch),
    handleChange: (val, label, type) => {
      dispatch(setFilterData(val, label, type))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageMain));



// WEBPACK FOOTER //
// ./src/pages/PageMain/index.js